import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "content", "icon"]
  static values = {
    openByDefault: { type: Number, default: 0 },
    allowMultiple: { type: Boolean, default: false }
  }

  connect() {
    // If openByDefaultValue is a positive number, open that specific accordion
    if (this.itemTargets.length > 0 && this.openByDefaultValue >= 0) {
      // If openByDefaultValue is 1, open all accordions
      if (this.openByDefaultValue === 1) {
        this.itemTargets.forEach((_, index) => {
          this.open(index);
        });
      }
      // Otherwise open the specific accordion at index
      else if (this.openByDefaultValue < this.itemTargets.length) {
        this.toggle(this.openByDefaultValue);
      }
    }
  }

  toggle(indexOrEvent) {
    let index;

    if (typeof indexOrEvent === 'number') {
      index = indexOrEvent;
    } else {
      const clickedElement = indexOrEvent.currentTarget;
      const itemElement = clickedElement.closest('[data-accordion-target="item"]');
      index = this.itemTargets.indexOf(itemElement);
      console.log('Clicked element:', clickedElement);
      console.log('Item element:', itemElement);
      console.log('Index:', index);
    }

    if (index === -1) return;

    const content = this.contentTargets[index];
    const icon = this.iconTargets[index];
    const isOpen = content.classList.contains('is-open');

    if (!this.allowMultipleValue) {
      this.closeAll();
    }

    if (isOpen) {
      this.close(index);
    } else {
      this.open(index);
    }
  }

  open(index) {
    const content = this.contentTargets[index]
    const icon = this.iconTargets[index]

    content.classList.add('is-open')
    content.style.display = 'block'

    if (icon) {
      icon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />'
    }
  }

  close(index) {
    const content = this.contentTargets[index]
    const icon = this.iconTargets[index]

    content.classList.remove('is-open')
    content.style.display = 'none'

    if (icon) {
      icon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />'
    }
  }

  closeAll() {
    this.contentTargets.forEach((content, index) => {
      this.close(index)
    })
  }
}
